const initHeader = () => {
	const menu = document.querySelector('[data-mobile-menu]');
	const toggleButtons = document.querySelectorAll('[data-mobile-menu-toggle]');
	const closeButtons = document.querySelectorAll('[data-mobile-menu-close]');
	const overlay = document.querySelector('[data-mobile-menu-overlay]');

	if (!menu || !toggleButtons.length) {
		return;
	}

	const root = document.documentElement;
	const body = document.body;

	const openMenu = () => {
		menu.classList.add('is-open');
		menu.setAttribute('aria-hidden', 'false');
		root.classList.add('is-menu-open');
		body.classList.add('is-menu-open');

		toggleButtons.forEach((button) => {
			button.setAttribute('aria-expanded', 'true');
		});
	};

	const closeMenu = () => {
		menu.classList.remove('is-open');
		menu.setAttribute('aria-hidden', 'true');
		root.classList.remove('is-menu-open');
		body.classList.remove('is-menu-open');

		toggleButtons.forEach((button) => {
			button.setAttribute('aria-expanded', 'false');
		});
	};

	toggleButtons.forEach((button) => {
		button.addEventListener('click', () => {
			if (menu.classList.contains('is-open')) {
				closeMenu();
				return;
			}

			openMenu();
		});
	});

	closeButtons.forEach((button) => {
		button.addEventListener('click', closeMenu);
	});

	if (overlay) {
		overlay.addEventListener('click', closeMenu);
	}

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && menu.classList.contains('is-open')) {
			closeMenu();
		}
	});

	const menuLinks = menu.querySelectorAll('a');

	menuLinks.forEach((link) => {
		link.addEventListener('click', closeMenu);
	});
};

document.addEventListener('DOMContentLoaded', initHeader);